import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISelfAlertIconDetailsAPIData, SelfAlertIconDetailsModel } from '../models/self_alert_icon_details_model';

angular
  .module('capability-ng-priority-feed')
  .factory(
    'loadSelfAlertIconDetailsCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSelfAlertIconDetailsModel: SelfAlertIconDetailsModel
    ): ICommand => {
      return defineCommandORM('loadSelfAlertIconDetailsCommand', (deferred: ng.IDeferred<IQuery[]>) => {
        const pullData = new Promise((resolve) =>
          $http({
            method: 'GET',
            url: `config/studentmenuitems/`
          }).then(resolve)
        );
        pullData
          .then(({ data }) => {
            const selfAlert: ISelfAlertIconDetailsAPIData = _4.find(data.data, (menuItem) => {
              return menuItem.nk === 'HAND_RAISE';
            });
            ngSelfAlertIconDetailsModel.write({ icon: selfAlert.icon, color: selfAlert.icon_color });
            localStorage.setItem('eab.navigate.self_alert_icon', JSON.stringify(selfAlert.icon));
            deferred.resolve();
          })
          .catch((e: any) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/load_self_alert_icon_details_command.ts